import React, { useContext, useEffect, useState } from 'react';
import IPage from '../../interfaces/IPage';
import { Container } from './MessageTemplate.styled';
import PageTitle from '../../components/page-title/PageTitle';
import {
  IconButton,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import CustomTableSortLabel from '../../components/custom-table-sort-label/CustomTableSortLabel';
import IMessageTemplate from '../../interfaces/iMessageTemplate';
import { AiTwotoneEdit } from 'react-icons/ai';
import CustomTablePagination from '../../components/custom-table-pagination/CustomTablePagination';
import { useMessageTemplateService } from '../../hooks/services/useMessageTemplateService';
import { useNavigate } from 'react-router-dom';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import { BiAddToQueue } from 'react-icons/bi';
import UserContext from '../../context/user/UserContext';
import { hasAccessToAction } from '../../util/hasAccessTo';

interface Props extends IPage {}

const headers = [
  { field: 'messageType_application', label: 'Aplicação', disableOrder: false },
  { field: 'name', label: 'Nome do Modelo', disableOrder: false },
  { field: 'title', label: 'Título', disableOrder: false },
  { field: 'greeting', label: 'Saldação', disableOrder: false },
  { field: 'footer', label: 'Despedida', disableOrder: false },
  { field: 'isDefault', label: 'Modelo Padrão', disableOrder: false },
  { field: 'actions', label: 'Ações', disableOrder: true },
];

const application = {
  WHATSAPP: 'Whatsapp',
  EMAIL: 'E-mail',
};

const EmailTemplateList = (props: Props) => {
  window.document.title = props.title;

  const [loading, setLoading] = useState(false);
  const [messageTemplates, setMessageTemplates] = useState<IMessageTemplate[] | null>(null);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
  const [orderField, setOrderField] = useState<string>('messageType_application');

  const request = useMessageTemplateService();
  const navigate = useNavigate();
  const toastr = useToastrVanila();

  const { state } = useContext(UserContext);
  const { resourcesWithActions } = state;
  
  const isEdit = hasAccessToAction(
    ["modelos-mensagem-atestado-web"],
    resourcesWithActions, 
    "Editar"
  );
    
  useEffect(() => {
    listMessageTemplates(perPage, currentPage, orderField, orderDirection);
  }, []);

  const listMessageTemplates = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
  ) => {
    setLoading(true);
    await request
      .list(perPage, currentPage + 1, orderField, orderDirection)
      .then(result => {
        setMessageTemplates([...result?.data]);
        setTotalRows(result.totalRows);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  return (
    <Container>
      <PageTitle title="LISTAGEM DE MODELOS DE MENSAGENS">
        <Tooltip title="Cadastrar novo" placement="left-start">
          <IconButton onClick={() => navigate(`/modelo-mensagem/${0}/new`)} color="inherit" disabled={!isEdit}>
            <BiAddToQueue />
          </IconButton>
        </Tooltip>
      </PageTitle>
      <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              {headers.map(header => {
                return (
                  <CustomTableSortLabel
                    key={header.field}
                    perPage={perPage}
                    currentPage={currentPage}
                    orderField={orderField}
                    field={header.field}
                    label={header.label}
                    disableOrder={header.disableOrder}
                    handleRequest={listMessageTemplates}
                    direction={orderDirection}
                    setField={setOrderField}
                    setDirection={setOrderDirection}
                  />
                );
              })}
            </TableRow>
          </TableHead>
          {
            <TableBody>
              {messageTemplates &&
                messageTemplates.map(template => {
                  return (
                    <TableRow key={template.id} hover={true}>
                      <TableCell>{application[template.messageType.application]}</TableCell>
                      <TableCell>{template.name}</TableCell>
                      <TableCell>{template.title}</TableCell>
                      <TableCell>{template.greeting}</TableCell>
                      <TableCell>{template.footer}</TableCell>
                      <TableCell>{template.isDefault ? 'Sim' : 'Não'}</TableCell>

                      <TableCell>
                        <Tooltip title="Editar" placement="top">
                          <IconButton onClick={() => navigate(`/modelo-mensagem/${template.id}/edit`)}>
                            <AiTwotoneEdit style={{ fontSize: '15px' }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          }
        </Table>
      </TableContainer>
      <CustomTablePagination
        totalRows={totalRows}
        currentPage={currentPage}
        perPage={perPage}
        handleRequest={listMessageTemplates}
        setPerPage={setPerPage}
        setCurrentPage={setCurrentPage}
        orderField={orderField}
        orderDirection={orderDirection}
      />
    </Container>
  );
};

export default EmailTemplateList;
